<template>
  <div class="module-dashboard-h">
    
    <div class="m-dash-row">
      
      <b-button @click="open_menu" class="d-block d-lg-none button-nav-icon">
        <span class="nav-icon"></span>
      </b-button>

      <img class="module-name" src="../assets/images/logo_deskontime.png">

      <div v-if="search" class="main-items-search d-none d-lg-flex">
        <input class="form-control-plaintext" v-on:keyup="buscar" 
        v-model="busqueda" type="text" placeholder="Buscar..." :disabled="current_main_item_loading">
        <i class="fa fa-search"></i>
      </div>

      <div v-if="!search" style="margin-right: auto;"></div>

      <div :class="((item.id==0)?('dash-container-first'):('dash-container')) + ' d-none d-lg-table'" v-for="item in counter_data" :key="item.id">
        <span class="dash-value" v-if="!counter_loading">{{ item.value }}</span>
        <span class="dash-label" v-if="!counter_loading">{{ item.text }}</span>
        <beat-loader :loading="counter_loading" color="#313946" size="10px"></beat-loader>
      </div>

      <div class="onhover-dropdown d-block">
        <div class="media align-items-center" style="height: 100%;">
          <img class="align-self-center pull-right rounded-circle" :src="avatar">
          <div class="dotted-animation"><span class="animate-circle"></span><span class="main-circle"></span></div>
        </div>
        <ul class="profile-dropdown onhover-show-div p-3" style="width:250px !important;">

          <li class="login-user-data">
            <div class="user-image-container">
              <div class="user-image">
                <img class="align-self-center pull-right rounded-circle-xl" :src="avatar">
              </div>
              <div class="user-name">
                <div class="user-name-text">
                  <span style="text-transform: capitalize;">{{ user_info.displayName }}</span>
                </div>
              <button class="change-image-button">
                <li @click="change_image"><a>Cambiar avatar</a></li>
              </button>
              </div>
            </div>
          </li>

          <li class="separador"></li>

          <li class="option" @click="change_password"><a><feather class="option-icon" type="user"></feather> Cambiar Contraseña</a></li>
          
          <li class="option" @click="logout" ><a><feather class="option-icon" type="log-out"></feather> Salir</a></li>

        </ul>
      </div>
      
    </div>

    <UsuarioUpdateAvatar ref="UsuarioUpdateAvatar" v-on:closeModal="closeModal" :key="UsuarioUpdateAvatarRandomKey"/>

  </div>
</template>
<script>

import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import UsuarioUpdateAvatar from './seguridad/usuarios/UsuarioUpdateAvatar'

export default {
  components: {
    BeatLoader,
    UsuarioUpdateAvatar
  },
  props: {
      search: {
        default: true,
        type: Boolean,
      },
      counter_data: {
        default: [],
        type: Array,
      },
      counter_loading: {
        default: false,
        type: Boolean,
      },
    },
  data() {
    return {
      user_info: {},
      busqueda: undefined,
      current_main_item_loading: false,
      avatar: "https://bckt-front-desk.s3.us-east-2.amazonaws.com/default-avatar.png",
      UsuarioUpdateAvatarRandomKey: 1
    }
  },
  mounted() {
    this.user_info = JSON.parse(localStorage.userinfo)
  
    try {

      this.$http.secured.get('/auth/v1/users/', { params: { type: "getUserAvatar" } })
        .then(response => {
          if (response.data){
            this.avatar = response.data;
          }
          
        })
        .catch(error => this.showError(error))
    } catch (error) {
      this.showError(error)
    }
    
  },
  methods: {
    open_menu () {
      this.$emit('clicked', true)
    },
    buscar (event) {
      if (event.code == "Enter" || event.code == "NumpadEnter") {
        this.$emit('searching', this.busqueda)  
      } 
    },
    change_image () {
      this.$bvModal.show("UsuarioUpdateAvatar")
    },
    change_password () {
      
      this.$router.push('/auth/change_password/' + localStorage.email + '/' + localStorage.id)
    },
    closeModal () {
      if (localStorage.avatar != '' && localStorage.avatar != undefined) {
        this.avatar = localStorage.avatar
      }
    },
    logout () {
      try {
        this.$http.secured.delete('/auth/v1/login/' + localStorage.id)
          .then(response => {
            localStorage.clear()
            this.$router.replace('/auth/login')
          })
          .catch(error => this.showError(error))
      } catch (error) {
        this.showError(error)
      }
    }
  }
}
</script>
